// Automated Advertising Pricing System
// Dynamic pricing based on demand, content relevance, and performance metrics

export const advertisingSpaces = [
  // Blog Post 1: The Azores - High demand, trending destination
  {
    id: 'azores-1',
    blogPostId: 1,
    position: 'header-banner',
    location: 'Top of blog post, below title',
    size: '728x90',
    basePrice: 75,
    currentPrice: 85,
    status: 'available',
    description: 'Premium header placement for trending destination',
    demandLevel: 'high',
    contentRelevance: 'travel-hotspots',
    performanceScore: 9.2,
    viewsPerMonth: 2500,
    ctr: 0.045
  },
  {
    id: 'azores-2',
    blogPostId: 1,
    position: 'sidebar-top',
    location: 'Right sidebar, top position',
    size: '300x250',
    basePrice: 55,
    currentPrice: 62,
    status: 'booked',
    description: 'Sidebar placement for engaged readers',
    demandLevel: 'high',
    contentRelevance: 'travel-hotspots',
    performanceScore: 8.8,
    viewsPerMonth: 2500,
    ctr: 0.038
  },
  {
    id: 'azores-3',
    blogPostId: 1,
    position: 'inline-content',
    location: 'Within article content, after first paragraph',
    size: '600x200',
    basePrice: 65,
    currentPrice: 72,
    status: 'available',
    description: 'Native content integration',
    demandLevel: 'high',
    contentRelevance: 'travel-hotspots',
    performanceScore: 9.0,
    viewsPerMonth: 2500,
    ctr: 0.052
  },

  // Blog Post 2: Austrian Alpine Adventure - Adventure travel niche
  {
    id: 'austria-1',
    blogPostId: 2,
    position: 'header-banner',
    location: 'Top of blog post, below title',
    size: '728x90',
    basePrice: 60,
    currentPrice: 68,
    status: 'available',
    description: 'Premium header placement for adventure content',
    demandLevel: 'medium',
    contentRelevance: 'adventure-travel',
    performanceScore: 8.5,
    viewsPerMonth: 1800,
    ctr: 0.042
  },
  {
    id: 'austria-2',
    blogPostId: 2,
    position: 'sidebar-top',
    location: 'Right sidebar, top position',
    size: '300x250',
    basePrice: 45,
    currentPrice: 50,
    status: 'available',
    description: 'Sidebar placement for adventure enthusiasts',
    demandLevel: 'medium',
    contentRelevance: 'adventure-travel',
    performanceScore: 8.2,
    viewsPerMonth: 1800,
    ctr: 0.035
  },

  // Blog Post 3: Slovenia Budget Travel - Budget-conscious audience
  {
    id: 'slovenia-1',
    blogPostId: 4,
    position: 'header-banner',
    location: 'Top of blog post, below title',
    size: '728x90',
    basePrice: 50,
    currentPrice: 55,
    status: 'available',
    description: 'Header placement for budget travel content',
    demandLevel: 'medium',
    contentRelevance: 'budget-travel',
    performanceScore: 7.8,
    viewsPerMonth: 1500,
    ctr: 0.040
  },

  // Blog Post 4: Solo Travel Safety - High-value content
  {
    id: 'safety-1',
    blogPostId: 5,
    position: 'header-banner',
    location: 'Top of blog post, below title',
    size: '728x90',
    basePrice: 70,
    currentPrice: 78,
    status: 'booked',
    description: 'Premium placement for safety content',
    demandLevel: 'high',
    contentRelevance: 'travel-safety',
    performanceScore: 9.1,
    viewsPerMonth: 2200,
    ctr: 0.048
  },

  // Blog Post 5: Hidden Gems Europe - Broad appeal
  {
    id: 'hidden-gems-1',
    blogPostId: 6,
    position: 'header-banner',
    location: 'Top of blog post, below title',
    size: '728x90',
    basePrice: 65,
    currentPrice: 72,
    status: 'available',
    description: 'Header placement for popular content',
    demandLevel: 'high',
    contentRelevance: 'travel-hotspots',
    performanceScore: 8.9,
    viewsPerMonth: 2800,
    ctr: 0.046
  },

  // Blog Post 6: Japan Art Islands - Cultural niche
  {
    id: 'japan-1',
    blogPostId: 8,
    position: 'header-banner',
    location: 'Top of blog post, below title',
    size: '728x90',
    basePrice: 55,
    currentPrice: 60,
    status: 'available',
    description: 'Header placement for cultural content',
    demandLevel: 'medium',
    contentRelevance: 'culture-art',
    performanceScore: 8.0,
    viewsPerMonth: 1200,
    ctr: 0.035
  },

  // Blog Post 7: Digital Nomad Colombia - Trending topic
  {
    id: 'colombia-1',
    blogPostId: 10,
    position: 'header-banner',
    location: 'Top of blog post, below title',
    size: '728x90',
    basePrice: 80,
    currentPrice: 88,
    status: 'available',
    description: 'Premium placement for trending topic',
    demandLevel: 'very-high',
    contentRelevance: 'digital-nomad',
    performanceScore: 9.4,
    viewsPerMonth: 3200,
    ctr: 0.055
  },

  // Blog Post 8: Transylvania - Niche destination
  {
    id: 'transylvania-1',
    blogPostId: 11,
    position: 'header-banner',
    location: 'Top of blog post, below title',
    size: '728x90',
    basePrice: 45,
    currentPrice: 48,
    status: 'available',
    description: 'Header placement for niche destination',
    demandLevel: 'low',
    contentRelevance: 'travel-hotspots',
    performanceScore: 7.5,
    viewsPerMonth: 800,
    ctr: 0.030
  },

  // Blog Post 9: Uzbekistan Silk Road - Cultural content
  {
    id: 'uzbekistan-1',
    blogPostId: 13,
    position: 'header-banner',
    location: 'Top of blog post, below title',
    size: '728x90',
    basePrice: 50,
    currentPrice: 54,
    status: 'available',
    description: 'Header placement for cultural content',
    demandLevel: 'medium',
    contentRelevance: 'culture-art',
    performanceScore: 7.9,
    viewsPerMonth: 1000,
    ctr: 0.032
  },

  // Blog Post 10: Patagonia - Adventure content
  {
    id: 'patagonia-1',
    blogPostId: 14,
    position: 'header-banner',
    location: 'Top of blog post, below title',
    size: '728x90',
    basePrice: 60,
    currentPrice: 66,
    status: 'available',
    description: 'Header placement for adventure content',
    demandLevel: 'medium',
    contentRelevance: 'adventure-travel',
    performanceScore: 8.3,
    viewsPerMonth: 1600,
    ctr: 0.038
  },

  // Blog Post 11: Faroe Islands - Photography destination
  {
    id: 'faroe-1',
    blogPostId: 15,
    position: 'header-banner',
    location: 'Top of blog post, below title',
    size: '728x90',
    basePrice: 55,
    currentPrice: 59,
    status: 'available',
    description: 'Header placement for photography destination',
    demandLevel: 'medium',
    contentRelevance: 'travel-hotspots',
    performanceScore: 8.1,
    viewsPerMonth: 1400,
    ctr: 0.036
  },

  // Blog Post 12: Activity Holidays - New category
  {
    id: 'activity-1',
    blogPostId: 16,
    position: 'header-banner',
    location: 'Top of blog post, below title',
    size: '728x90',
    basePrice: 70,
    currentPrice: 75,
    status: 'available',
    description: 'Header placement for new activity category',
    demandLevel: 'high',
    contentRelevance: 'activity-holidays',
    performanceScore: 8.7,
    viewsPerMonth: 2000,
    ctr: 0.044
  }
];

// Automated Pricing Algorithm
export const calculateDynamicPrice = (space) => {
  const {
    basePrice,
    demandLevel,
    performanceScore,
    viewsPerMonth,
    ctr,
    contentRelevance
  } = space;

  // Demand multiplier
  const demandMultipliers = {
    'very-high': 1.3,
    'high': 1.15,
    'medium': 1.0,
    'low': 0.85
  };

  // Performance multiplier based on CTR and views
  const performanceMultiplier = Math.min(1.5, Math.max(0.7, 
    (performanceScore / 10) * (ctr / 0.04) * (viewsPerMonth / 2000)
  ));

  // Content relevance multiplier
  const relevanceMultipliers = {
    'travel-hotspots': 1.2,
    'adventure-travel': 1.1,
    'culture-art': 1.0,
    'budget-travel': 0.9,
    'travel-safety': 1.15,
    'digital-nomad': 1.25,
    'activity-holidays': 1.1
  };

  const demandMultiplier = demandMultipliers[demandLevel] || 1.0;
  const relevanceMultiplier = relevanceMultipliers[contentRelevance] || 1.0;

  return Math.round(basePrice * demandMultiplier * performanceMultiplier * relevanceMultiplier);
};

// Update all prices based on current demand and performance
export const updateAllPrices = () => {
  return advertisingSpaces.map(space => ({
    ...space,
    currentPrice: calculateDynamicPrice(space)
  }));
};

// Get pricing tiers for different advertiser types
export const getPricingTiers = () => {
  return {
    starter: {
      name: 'Starter Package',
      price: '£299',
      duration: '1 month',
      features: [
        'Banner ad on homepage',
        'Featured in 2 blog posts',
        'Social media mention',
        'Email newsletter inclusion',
        'Basic analytics report'
      ],
      description: 'Perfect for small businesses and startups'
    },
    premium: {
      name: 'Premium Package',
      price: '£799',
      duration: '3 months',
      features: [
        'All Starter features',
        'Sponsored blog post',
        'Banner ad on all pages',
        'Travel companion matching integration',
        'Priority placement in search results',
        'Detailed analytics dashboard',
        'Dedicated account manager'
      ],
      description: 'Ideal for established travel brands'
    },
    enterprise: {
      name: 'Enterprise Package',
      price: '£1,999',
      duration: '6 months',
      features: [
        'All Premium features',
        'Custom content creation',
        'Exclusive travel group sponsorship',
        'Personality quiz integration',
        'White-label solutions',
        'API access for custom integrations',
        'Quarterly strategy sessions',
        'Performance guarantees'
      ],
      description: 'For major travel companies'
    }
  };
};

// Automated ad placement recommendations
export const getAdRecommendations = (advertiserType, budget, targetAudience) => {
  const recommendations = [];
  
  // Filter spaces based on advertiser criteria
  const relevantSpaces = advertisingSpaces.filter(space => {
    if (budget && space.currentPrice > budget) return false;
    if (targetAudience && !space.contentRelevance.includes(targetAudience)) return false;
    return space.status === 'available';
  });

  // Sort by performance score and recommend top options
  return relevantSpaces
    .sort((a, b) => b.performanceScore - a.performanceScore)
    .slice(0, 5)
    .map(space => ({
      ...space,
      recommendationReason: getRecommendationReason(space, advertiserType),
      estimatedROI: calculateEstimatedROI(space)
    }));
};

const getRecommendationReason = (space, advertiserType) => {
  const reasons = {
    'travel-agency': `High engagement in ${space.contentRelevance} content`,
    'hotel-chain': `Premium placement with ${space.viewsPerMonth} monthly views`,
    'tour-operator': `Perfect match for ${space.contentRelevance} audience`,
    'travel-tech': `High CTR of ${(space.ctr * 100).toFixed(1)}%`,
    'budget-travel': `Cost-effective placement at £${space.currentPrice}/week`
  };
  
  return reasons[advertiserType] || 'High-performing placement with excellent engagement';
};

const calculateEstimatedROI = (space) => {
  const estimatedClicks = space.viewsPerMonth * space.ctr;
  const estimatedRevenue = estimatedClicks * 0.05; // Assume 5% conversion rate
  const cost = space.currentPrice * 4; // Monthly cost
  return Math.round((estimatedRevenue / cost) * 100);
};

// Get available spaces with current pricing
export const getAvailableSpaces = () => {
  return advertisingSpaces.filter(space => space.status === 'available');
};

// Get booked spaces
export const getBookedSpaces = () => {
  return advertisingSpaces.filter(space => space.status === 'booked');
};

// Get spaces by blog post
export const getSpacesByBlogPost = (blogPostId) => {
  return advertisingSpaces.filter(space => space.blogPostId === parseInt(blogPostId));
};

// Calculate total revenue
export const getTotalRevenue = () => {
  const bookedSpaces = getBookedSpaces();
  return bookedSpaces.reduce((total, space) => total + space.currentPrice, 0);
};

// Calculate available revenue potential
export const getAvailableRevenue = () => {
  const availableSpaces = getAvailableSpaces();
  return availableSpaces.reduce((total, space) => total + space.currentPrice, 0);
};

// Get performance analytics
export const getPerformanceAnalytics = () => {
  const totalViews = advertisingSpaces.reduce((sum, space) => sum + space.viewsPerMonth, 0);
  const avgCTR = advertisingSpaces.reduce((sum, space) => sum + space.ctr, 0) / advertisingSpaces.length;
  const avgPerformance = advertisingSpaces.reduce((sum, space) => sum + space.performanceScore, 0) / advertisingSpaces.length;
  
  return {
    totalViews,
    avgCTR: (avgCTR * 100).toFixed(2),
    avgPerformance: avgPerformance.toFixed(1),
    totalSpaces: advertisingSpaces.length,
    availableSpaces: getAvailableSpaces().length,
    bookedSpaces: getBookedSpaces().length,
    totalRevenue: getTotalRevenue(),
    potentialRevenue: getAvailableRevenue()
  };
}; 